import React from 'react'
import styled from 'styled-components'
import Cards from '../../../components/ui/card'
import {Medical, MultiMedicals} from '../../../assets/icons'
import { BOOKING_TYPES } from '../constants'
import colors from '../../../styles/colors'
import fonts from '../../../styles/fonts'
import { Title } from '../../../components/ui/text'
import { HideBackTextOnMobileHeader as BackHeader } from '../../../components/ui/header'
import { CardSection, Section } from '../../../styles/sections'

const Container = styled.div`
	width: 100%;
`

const AppointmentOptions = ({ onNext, onSelectBookingType, onBack }) => {
	const cardsList = [
		{
			id: 'single-appointment',
			title: 'Turnos individuales',
			Icon: Medical,
			routes: BOOKING_TYPES.SINGLE
		},
		{
			id: 'multiple-appointment',
			title: 'Múltiples turnos',
			Icon: MultiMedicals,
			routes: BOOKING_TYPES.MULTIPLE
		}
	]

	const handleSelectMode = mode => {
		if (onSelectBookingType) {
			onSelectBookingType(mode)
		}
		onNext({ bookingType: mode })
	}

	return (
		<Container>
			<BackHeader
				onBack={onBack}
				hideBackOnMobile={false}
				title={
					<Title
						size={fonts.fontSizes.xxl}
						color={colors.text.titleText}
						margin="0 0 24px 0"
						fontWeight={fonts.fontWeight.semibold}
					>
						¿Qué tipo de turno?
					</Title>
				}
			/>
			<Section>
				<CardSection>
					<Cards
						iconColor={colors.brand.green}
						list={cardsList}
						onClick={handleSelectMode}
						mobileColumns={1}
						fullMobileCard={true}
					/>
				</CardSection>
			</Section>
		</Container>
	)
}

export default AppointmentOptions